import React from 'react';
import '../css/RetosAnteriores.css';
import RecaudacionHistorica from '../components/RecaudacionHistorica';
import Colaboradores from './Colaboradores';

const listaRetos = [
  {
    year: "2021",
    titulo: "El Inicio de un Sueño",
    descripcion: "Fue el primer reto como ensayo de lo que vendría. Un desafío de resistencia pura donde pusimos a prueba nuestras fuerzas por primera vez.",
    hitos: ["Everesting Non Stop", "8.848m ascendidos", "18 horas de esfuerzo", "Éxito total"],
    imagen: "https://firebasestorage.googleapis.com/v0/b/elretodecarmen-3a0ae.firebasestorage.app/o/imagenes%20presentaci%C3%B3n%2FReto2021.jpeg?alt=media&token=a93c33d4-8132-407b-bd57-da4c378d2ac8",
    color: "#f8f0fb", 
    accent: "#7b1fa2"  
  },
  {
    year: "2022",
    titulo: "Desafío 10K Monfón",
    descripcion: "Subimos el nivel con un objetivo de 10.000m ascendidos en la misma subida (Monfón). Una jornada épica que demostró el poder de la solidaridad.",
    hitos: ["10.000m ascendidos", "21 horas sin parar", "17.000€ recaudados", "A favor de Pequeño Deseo"],
    imagen: "https://firebasestorage.googleapis.com/v0/b/elretodecarmen-3a0ae.firebasestorage.app/o/imagenes%20presentaci%C3%B3n%2FReto%202022.jpeg?alt=media&token=5c391585-9400-4706-8d9a-c69be3403c71",
    color: "#fff0f6", 
    accent: "#db2777"  
  },
  {
    year: "2024",
    titulo: "De Fisterra a Higueruela",
    descripcion: "Logramos unir el Faro de Fisterra con nuestro pueblo en un trayecto Non Stop que cruzó media España por una causa mayor.",
    hitos: ["1.150 km recorridos", "44 horas de pedaleo", "28.223€ recaudados", "Impacto histórico"],
    imagen: "https://firebasestorage.googleapis.com/v0/b/elretodecarmen-3a0ae.firebasestorage.app/o/imagenes%20presentaci%C3%B3n%2FReto2024.jpeg?alt=media&token=37b556be-507d-4658-896b-cbbeb6b306fa",
    color: "#f8f0fb",
    accent: "#7b1fa2"
  },
    {
    year: "2026",
    titulo: "DisneyLand París --> Higueruela",
    descripcion: "Desafiamos los límites en una travesía non-stop desde Disneyland París hasta Higueruela. Una increíble aventura solidaria que unió corazones por una gran causa.",
    hitos: ["1.450km recorridos", "2 días y medio sin parar", "43.066€ recaudados", "A favor de Pequeño Deseo"],
    imagen: "https://firebasestorage.googleapis.com/v0/b/elretodecarmen-3a0ae.firebasestorage.app/o/fotosReto%2F01disney.jpeg?alt=media&token=f8c605a8-ea48-4917-8a8a-2e5dbb411e40",
    color: "#fff0f6", 
    accent: "#db2777"  
  },
];

// Nuevo Array para los vídeos
const listaVideos = [
  {
    titulo: "Ancha es Castilla-La Mancha (CMMedia)",
    url: "https://www.cmmedia.es/play/tv/ancha-es-castilla-la-mancha/reto-carmen.html",
    miniatura: "https://firebasestorage.googleapis.com/v0/b/elretodecarmen-3a0ae.firebasestorage.app/o/imagenes%20enlaces%20de%20videos%2Fvideo%20clm.png?alt=media&token=517c4fce-35fb-4a13-8015-6e152f7f0d23",
    medio: "Televisión"
  },
  {
    titulo: "Reportaje Especial Facebook Watch",
    url: "https://www.facebook.com/watch/?v=977033617078594",
    miniatura: "https://firebasestorage.googleapis.com/v0/b/elretodecarmen-3a0ae.firebasestorage.app/o/imagenes%20enlaces%20de%20videos%2Fvideo%20face.png?alt=media&token=53106acf-d6dd-4b48-8d26-507066dd2804",
    medio: "Redes Sociales"
  }
];

const RetosAnteriores = () => {
  return (
    <section className="retos-section">
      <div className="retos-header">
        <h2 className="retos-main-title">Nuestra <span className="purple-bold">Trayectoria</span></h2>
        <p className="retos-intro">
          Cada año, pedalada tras pedalada, hemos ido construyendo un camino de solidaridad. 
          Estos son los hitos que nos han traído hasta aquí.
        </p>
      </div>
      
      <RecaudacionHistorica/>

      <div className="retos-container">
        {listaRetos.map((reto, index) => (
          <div 
            key={reto.year} 
            className={`reto-item ${index % 2 !== 0 ? 'reverse' : ''}`}
            style={{ 
              backgroundColor: reto.color, 
              '--accent-color': reto.accent,
              '--bg-stats': '#ffffff'
            }}
          >
            <div className="reto-image-wrapper">
              <img src={reto.imagen} alt={reto.titulo} className="reto-img" />
              <div className="reto-year-badge" style={{ backgroundColor: reto.accent }}>
                {reto.year}
              </div>
            </div>
            
            <div className="reto-info">
              <h3 style={{ color: reto.accent }}>{reto.titulo}</h3>
              <p className="reto-desc">{reto.descripcion}</p>
              <ul className="reto-stats">
                {reto.hitos.map((hito, i) => (
                  <li key={i} className="reto-stat-tag">
                    {hito}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>

      {/* SECCIÓN DE VÍDEOS / PRENSA */}
      <div className="videos-press-section">
        <h2 className="retos-main-title">El Reto en los <span className="pink-text">Medios</span></h2>
        <div className="videos-grid">
          {listaVideos.map((video, index) => (
            <a 
              href={video.url} 
              target="_blank" 
              rel="noopener noreferrer" 
              key={index} 
              className="video-card"
            >
              <div className="video-thumbnail-wrapper">
                <img src={video.miniatura} alt={video.titulo} className="video-thumbnail" />
                <div className="play-overlay">
                  <span className="play-icon">▶</span>
                </div>
                <span className="video-tag">{video.medio}</span>
              </div>
              <div className="video-info-box">
                <h4>{video.titulo}</h4>
                <p>Ver reportaje completo →</p>
              </div>
            </a>
          ))}
        </div>
      </div>
         <div style={{ 
        width: '100%', 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center',
        marginTop: '60px', // Espacio respecto al mapa
        textAlign: 'center'
      }}>
      </div>
    </section>
  );
};

export default RetosAnteriores;